// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRadiusUprightOutlinedSvg from "@fishx/icons-svg/es/asn/PRadiusUprightOutlined";
import FishxIcon from '../components/FishxIcon';

var PRadiusUprightOutlined = function PRadiusUprightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRadiusUprightOutlinedSvg
  }));
};

PRadiusUprightOutlined.displayName = 'PRadiusUprightOutlined';
export default React.forwardRef(PRadiusUprightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRadiusUprightOutlined.js
// module id = 3575
// module chunks = 0